import React, { Component } from 'react'
import { connect } from 'react-redux'

import { Card, Table, Alert, Tag, Divider } from 'antd'
import { req_single_cms_school_student, req_single_cms_learnmap_yearplan, req_single_cms_learnmap_completed_talent } from '../../api'
import { getNowAcademicYear, getNowAcademicSemester } from '../../utils/dateUtil'

class CoursemapStudentCompletedTalent extends Component {
    // 基礎通用參數 //////////////////////////////////////////////  
    state = {
        items: [],
        deviceWidth: 0,
        loading: false,
        nowAcademicYear: getNowAcademicYear(new Date()),
        nowAcademicSemester: getNowAcademicSemester(new Date()),
    }

    componentDidMount() {
        window.addEventListener('resize', this.resize.bind(this))
        this.resize()
        this.api_init_items()
    }

    // componentWillUnmount() {
    //     window.removeEventListener("resize", this.resize.bind(this))
    // }

    resize() {
        this.setState({ deviceWidth: window.innerWidth });
    }

    // 遠端數據處理 //////////////////////////////////////////////
    api_init_items = async () => {
        const { userCode, token } = this.props.user
        this.setState({ loading: true, items: [] })
        const result = await req_single_cms_school_student(userCode, token)
        if (result) {
            const { nowAcademicYear, nowAcademicSemester } = this.state
            const { enrollmnetYear, studentId, departmentInsideCode } = result
            let grade = nowAcademicYear - enrollmnetYear
            let semester = 1
            if (nowAcademicSemester === '2') {
                grade = grade + 1
                semester = nowAcademicSemester - 1
            }
            else {
                if (grade === 0) {
                    //一年級上學期
                    grade = 1
                    semester = 1
                }
                else {
                    semester = 2
                }
            }
            const showGradeSemester = grade.toString() + semester.toString()
            //console.log('showGradeSemester',showGradeSemester)

            const yearplan = await req_single_cms_learnmap_yearplan(result, token)
            //console.log(yearplan)
            if (yearplan) {
                const record = {
                    gidLearnMapMeta: yearplan.gidLearnMapMeta,
                    nidLearnMapMeta: yearplan.nidLearnMapMeta,
                    studentId: studentId,
                    department: departmentInsideCode,
                    enrollmnetYear: enrollmnetYear,
                    gradeSemester: showGradeSemester,
                }
                const completedtalents = await req_single_cms_learnmap_completed_talent(record, token)
                if (completedtalents) {
                    if (completedtalents.total > 0) {
                        const items = completedtalents.data
                        this.setState({ items, loading: false })
                    }
                } else {
                    this.setState({ loading: false })
                }

            } else {
                this.setState({ loading: false })
            }
        } else {
            this.setState({ loading: false })
        }
    }

    /////////////////////////////////////////////////////////////  
    render() {
        const { loading, deviceWidth, items } = this.state
        const columns = [
            {
                title: '目標人才名稱',
                dataIndex: 'talentTwName',
                width: 60,
                render: (row) => {
                  
                    return (
                        <div className="text-center">{row}</div>
                    )
                },
            },
            {
                title: '完成度',
                width: 40,
                render: (item) => {
                    const { talentValueMe } = item
                    return (
                        <span>{(Math.sqrt(talentValueMe) * 10).toFixed(2)}%</span>
                    )
                },
                responsive: ['md'],
            },
            {
                title: '百分等級(PR)值',
                width: 60,
                render: (item) => {
                    const { abilityPRValue, rankPRValue, studentTotal } = item
                    return (
                        <span>{abilityPRValue}%，(排名：第{rankPRValue}名，共{studentTotal}人)</span>
                    )
                },
            },
            {
                title: '說明',
                dataIndex: 'talentDescription',
                width: 200,
                responsive: ['md'],
            },
        ]
        const htmlItems = items.length > 0 ? (<>
            {deviceWidth > 800 ? (
                <Card>
                    <Table
                        bordered
                        style={{ width: '99%' }}
                        scroll={{ y: 500 }}
                        loading={loading}
                        rowKey='id'
                        dataSource={items}
                        pagination={false}
                        columns={columns}
                    />
                </Card>) : (<div className="row" >
                    {this.talents.map((row, idt) => <>
                        <div className="col-sm" style={{ marginTop: '5px' }} key={idt}>
                            <Card
                                key={idt}
                                title={<><i className="fas fa-universal-access"></i> {row.talentTwName}</>}
                                style={{ backgroundColor: 'rgba(255, 255, 255, 0.0)', border: 0 }}
                                headStyle={{ backgroundColor: 'rgba(75, 28, 90, 0.4)', border: 0 }}
                                bodyStyle={{ backgroundColor: 'rgba(248, 225, 255, 0.4)', border: 0 }}
                            >
                                <div><Tag color="magenta" key={idt}>完成度</Tag><span style={{ color: 'Blue' }}>{(Math.sqrt(row.talentValueMe) * 10).toFixed(2)}%</span></div>
                                <p />
                                <div><Tag color="magenta" key={idt}>PR值</Tag><span style={{ color: 'Blue' }}>{row.abilityPRValue}%，(排名：第{row.rankPRValue}名，共{row.studentTotal}人)</span></div>
                                <Divider orientation="left" plain key={idt}>
                                    人才描述
                                </Divider>
                                {row.talentDescription}
                            </Card>
                        </div>
                    </>)}
                </div>)}
            <Alert message="註：PR（又稱為百分等級）值，是先將該次測驗所有學生的量尺總分排序後，依照人數均分成一百等分，該學生大約會落在第幾個等分中。 簡單來說，若某位學生的PR值為90， 即表示該生的分數高於該次測驗全數約90%學生" type="success" />
        </>) : (<Alert
            message="無相關資訊(此功能僅適用日四技查詢)"
            type="warning"
            closable
        />)

        return (
            <> {loading ? (<div className='text-center'>
                <p />
                <button className="btn " type="button" disabled>
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ marginRight: '4px' }}></span>
                    Loading...
                </button>
            </div>) : (<>
                {htmlItems}
            </>)}</>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(CoursemapStudentCompletedTalent)